import React, { Component } from 'react';
import './App.css';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import autorepairdata from './autorepairdata';


class Main extends Component {

constructor(props) {
  super(props);
  this.state = {
    data: []
	}

this.fetchData = this.fetchData.bind(this)
this.clearData = this.clearData.bind(this)

}

fetchData = () => {
       this.setState({
        data: [...autorepairdata]
        });
  }

  deleteRow = (Name) => {
  const index = this.state.data.findIndex(data => {
    return data.Name === Name
  })

  this.state.data.splice(index, 1);
  this.setState({data: this.state.data})
}

clearData = () => {
  this.setState({ data: [] })
}



  render() {

const columns = [
    {
      Header: "Name",
      accessor: "Name",
      style: {textAlign: "center"},
    },
    {
      Header: "Address",
      accessor: "Address",
       style: {textAlign: "center"}
    },
    {
      Header: "Phone",
      accessor: "Phone",
      filterable: false,
      sortable: false,
       style: {textAlign: "center"}
    },
    {
      Header: "Website",
      accessor: "Website",
      filterable: false,
      sortable: false,
       style: {textAlign: "center"},
       width: 100,
       maxWidth: 100,
       minWidth: 100,
       Cell: props => {
        return(
          <div>
          <a href={props.original.Website}>Website</a>
          </div>
              )
        }
    },
    {
      Header: "Shop Image",
      accessor: "Picture",
      filterable: false,
      sortable: false,
       style: {textAlign: "center"},
       width: 100,
       maxWidth: 100,
       minWidth: 100,
       Cell: props => {
        return(
          <div>
           <a href={props.original.Picture}><img src={props.original.Picture} alt="n/a" width="45" height="45"/></a>
          
          </div>
              )
        }
    },
    {
      Header: "Actions",
      filterable: false,
      sortable: false,
       style: {textAlign: "center"},
       width: 100,
       maxWidth: 100,
       minWidth: 100,
       Cell: props => {
        return(
          <div>
          <button style={{backgroundColor: "#ee9ca7"}}
          onClick={() => {
            this.deleteRow(props.original.Name)
          }}>
          Delete</button>
          </div>
              )
        }
    }
    ] 

   const buttonStyle = {
  margin: "10px",
  fontSize: "14px",
  height: "40px",
  width: "150px",
  borderRadius: "10px",
  boxShadow: "1px 1px 0px 2px",
  cursor: "pointer"
}
   

    return (

      <div className="App">

      	<div style={{display: "flex", justifyContent: "center", border: "solid 1px", margin: "10px", borderRadius: "10px", boxShadow: "1px 1px 0px 1.5px"}}>
      <p>Extract data from The Yellow Pages.<br/>
      Auto Repair Shops in San Francisco.<br/>
      The data can be sorted by clicking on the column header.<br/>
      The data can be filtered by typing in the filter box.</p>
      </div>
      <div style={{display: "flex", justifyContent: "center"}}>
        <button style={buttonStyle} onClick={this.fetchData}>Fetch Data</button>
        <button style={buttonStyle} onClick={this.clearData}>Clear Data</button>
      </div>

        <ReactTable 
        columns={columns}
        data={this.state.data}
        filterable
        style={{background: "lightblue", margin: "20px", border: "1px solid"}}
        defaultPageSize={10}
        noDataText={"Get data by clicking the Fetch button."}
      >
      </ReactTable>  
        
      </div>
    );
  }
}

export default Main;
